// 激发模块
import { getPromptList, getWelcomePageConfiguration } from '@/api/prompt'
import { setLocalStorage, getLocalStorage } from '@/utils/locatonStorge'

import { knuthDurstenfeldShuffle } from '@/utils/randomNumber'
// import { getRandom } from '@/utils/randomNumber'

// let RandomList = getRandom(100)
// let LeftRandomList = getRandom(100)
let promptListPromise = null
const Prompt = {
  namespaced: true,

  state: {
    showPanel: getLocalStorage('showPanel') === 'true',
    promptModel: null, //
    showPromptTab: false, // 是否展示激发模块
    promptList: [], // 提示列表
    selectIndex: 0,
    sideStatus: 0, // 0:收起，1:窄屏，2：宽屏
    // 移动端
    showH5PromptPanel: false,
    end: false,
    // 是否刷新灵感
    prevUrl: '',
    welcomePageConfig: null
  },
  mutations: {
    SET_SHOW_PANEL: (state, showPanel) => {
      setLocalStorage('showPanel', showPanel)
      state.showPanel = showPanel
    },
    SET_PROMPT_MODEL(state, promptModel) {
      state.promptModel = promptModel
    },
    SET_SIDE_STATUS: (state, sideStatus) => {
      state.sideStatus = sideStatus
    },
    SET_SHOW_PROMPT_STATUS: (state, showPromptStatus) => {
      state.showPromptTab = showPromptStatus
    },
    SET_PROMPT_LIST: (state, promptList) => {
      state.promptList = promptList
    },
    SET_SELECT_INDEX: (state, promptList) => {
      state.selectIndex = promptList
    },
    SET_SHOW_H5_PROMPT_STATUS: (state, showH5PromptPanel) => {
      state.showH5PromptPanel = showH5PromptPanel
    },
    SET_PREV_URL: (state, val) => {
      state.prevUrl = val
    },
    SET_WELCOME_PAGE_CONFIGURATION: (state, val) => {
      state.welcomePageConfig = val
    }
  },
  getters: {
    keys: state => {
      const promptList = state.promptList.filter(l => l.key !== 'APP_New' && l.tab_use !== 0)
      return promptList.map(l => {
        return l.key || ''
      })
    },
    allList: (_, getters) => {
      let all = []
      const res = []
      const details = getters.detail || []
      details.forEach(item => {
        all = all.concat(item)
      })
      // 去重
      const seen = {}
      for (let i = 0; i < all.length; i++) {
        const item = all[i] || {}
        if (!seen[item.id]) {
          res.push(item)
          seen[item.id] = true
        }
      }
      return res
    },
    detail: state => {
      return state.promptList.map(l => {
        return l.detail || {}
      })
    },
    welcomePageConfig: state => {
      return state.welcomePageConfig
    },
    currentDetalList: (state, getters) => {
      const dataList = getters.detail[state.selectIndex] || []
      if (state.selectIndex === 0) {
        const otherData = getters.allList.slice(dataList.length)
        return [...dataList, ...knuthDurstenfeldShuffle(otherData)]
      }
      return dataList
    },
    showList: (_, getters) => {
      return getters.currentDetalList.map((l, index) => {
        l.displayText = l.text
        l.style = 1
        return l
      })
    },
    leftList: (_, getters) =>
      getters.currentDetalList
        .filter((_, index) => index % 2 === 0)
        .map((l, index) => {
          return {
            ...l,
            style: 1
          }
        }),
    rightList: (_, getters) =>
      getters.currentDetalList
        .filter((_, index) => index % 2 === 1)
        .concat()
        .map((l, index) => {
          return {
            ...l,
            style: 1
          }
        })
  },
  actions: {
    GetPromptList({ commit, state }, payload) {
      if (!payload?.url) return
      if (promptListPromise && state.prevUrl === payload.url) {
        return promptListPromise
      }
      commit('SET_PREV_URL', payload.url)
      commit('SET_PROMPT_LIST', [])
      promptListPromise = new Promise((resolve, reject) => {
        getPromptList({ url: payload.url })
          .then(res => {
            if (res.status === 0) {
              const result = res.result || []
              commit('SET_PROMPT_LIST', result)
              resolve()
            } else {
              reject(res.message || '请求错误')
            }
          })
          .catch(() => {
            commit('SET_PROMPT_LIST', [])
          })
      })
      return promptListPromise
    },
    GetWelcomePageConfiguration({ commit, state }, payload) {
      const { agent_id } = payload

      return new Promise((resolve, reject) => {
        getWelcomePageConfiguration(agent_id).then(result => {
          commit('SET_WELCOME_PAGE_CONFIGURATION', result)
          resolve()
        })
      })
    }
  }
}

export default Prompt
